import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { searchFixedIngredients } from "@/services/search_api";

const DEBOUNCE_MS = 200;

export function useFixedIngredientsSearch(rawQuery: string) {
  const [debounced, setDebounced] = useState(rawQuery.trim());

  useEffect(() => {
    const trimmed = rawQuery.trim();
    if (trimmed === debounced) return;
    const t = setTimeout(() => setDebounced(trimmed), DEBOUNCE_MS);
    return () => clearTimeout(t);
  }, [rawQuery, debounced]);

  return useQuery({
    queryKey: ["fixed-ingredients", debounced],
    queryFn: () => searchFixedIngredients(debounced),
    enabled: debounced.length > 0,
    staleTime: 30_000,
  });
}
